import { useRouter } from "next/router";
import Link from "next/link";
import MetaTags from "../../components/generic/MetaTags";
export default function Test() {
  const router = useRouter();
  const status = router.query.status;

  return (
    <>
      <MetaTags PageName="Payment Status"></MetaTags>
      <div
        className="flex flex-col p-4 items-center justify-center  text-center align-middle text-5xl font-bold border-2 border-slate-300 rounded-md m-10
    h-96"
      >
        <div className="flex flex-row">
          Payment{" "}
          <span
            className={`${
              status === "success" ? "text-green-500" : "text-red-500"
            } ml-2`}
          >
            {status}
          </span>
        </div>

        <span className="text-2xl font-medium my-7">
          <Link href="/">
            <span className="text-blue-500">Click here</span>
          </Link>{" "}
          to go back to home page
        </span>
      </div>
    </>
  );
}
